/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AshoreUserShortInfo model module.
 * @module model/AshoreUserShortInfo
 * @version V1
 */
class AshoreUserShortInfo {
    /**
     * Constructs a new <code>AshoreUserShortInfo</code>.
     * @alias module:model/AshoreUserShortInfo
     */
    constructor() { 
        
        AshoreUserShortInfo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AshoreUserShortInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AshoreUserShortInfo} obj Optional instance to populate.
     * @return {module:model/AshoreUserShortInfo} The populated <code>AshoreUserShortInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AshoreUserShortInfo();

            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('defaultTeamForUser')) {
                obj['defaultTeamForUser'] = ApiClient.convertToType(data['defaultTeamForUser'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AshoreUserShortInfo</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AshoreUserShortInfo</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }

        return true;
    }


}



/**
 * @member {Number} userId
 */
AshoreUserShortInfo.prototype['userId'] = undefined;

/**
 * @member {String} name
 */
AshoreUserShortInfo.prototype['name'] = undefined;

/**
 * @member {Boolean} defaultTeamForUser
 */
AshoreUserShortInfo.prototype['defaultTeamForUser'] = undefined;






export default AshoreUserShortInfo;

